import { API } from '../utils/constants'

const services = {
  list: API + '/users',
  delete: API + '/users',
  register: API + '/users',
}

export async function getAllUsers() {
  const _token = () => localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + _token(),
    },
  }
  let res: any = null

  await fetch(services.list, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function getUserById(id: any) {
  const _token = () => localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + _token(),
    },
  }
  let res: any = null

  await fetch(`${services.list}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function disableUser(id: any) {
  const _token = () => localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + _token(),
    },
  }
  let res: any = null

  await fetch(`${services.list}/disable/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function deleteUser(id: any) {
  const _token = () => localStorage.getItem('__token')
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + _token(),
    },
  }
  let res: any = null

  await fetch(`${services.delete}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function updatePassword(body: any) {
  const _token = () => localStorage.getItem('__token')
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + _token(),
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(`${services.register}/update-password`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function updateUser(id: any, body: any) {
  const _token = () => localStorage.getItem('__token')
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + _token(),
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(`${services.register}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}
